import { ReactNode, useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  const navigate = useNavigate();
  const { logout, user, isAuthenticated } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleLogout = () => {
    setMenuOpen(false);
    logout();
    navigate('/');
  };

  // Close on outside click
  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  return (
    <div className="layout">
      <header className="header">
        <div className="container flex-between">
          <Link to={isAuthenticated ? '/settings' : '/'} className="logo">
            <img src="/mosaic-icon.png" alt="mosaime" className="logo-icon-img" />
            <span className="logo-text">mosaime</span>
          </Link>

          {isAuthenticated ? (
            <div className="header-menu" ref={menuRef}>
              <button
                className="header-hamburger"
                aria-label="Open menu"
                aria-expanded={menuOpen}
                onClick={() => setMenuOpen((s) => !s)}
              >
                <span /><span /><span />
              </button>

              {menuOpen && (
                <div className="header-dropdown">
                  {user?.name && <div className="dropdown-name">{user.name}</div>}
                  <Link to="/settings" className="dropdown-link" onClick={() => setMenuOpen(false)}>Settings</Link>
                  <Link to="/feedback" className="dropdown-link" onClick={() => setMenuOpen(false)}>Feedback</Link>
                  <Link to="/blog" className="dropdown-link" onClick={() => setMenuOpen(false)}>Blog</Link>
                  <button className="dropdown-link dropdown-logout" onClick={handleLogout}>Logout</button>
                </div>
              )}
            </div>
          ) : (
            <div className="header-right">
              <Link to="/blog" className="header-link">Blog</Link>
              <Link to="/login" className="header-link">Log in</Link>
            </div>
          )}
        </div>
      </header>

      <main className="main">
        <div className="container">
          {children}
        </div>
      </main>
    </div>
  );
}

export default Layout;
